/* eslint-disable no-unused-vars */
import { withPreventFromUser } from '@hoc/withPreventFromUser'
import { loginAction, setIsLogedIn, setIsLoggingIn } from '@store/StaticStore/authSlice'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Formik } from 'formik'

import './Login.css'
import { ERR_LOGIN, ERR_NETWORK } from '@const/error'
import { useQuery } from '@utils/useQuery'
import { Link } from 'react-router-dom'

type Props = {}

const Login: React.FC<Props> = () => {
  // const { t } = useTranslation()
  const { isLoggingIn, isLoggedIn } = useSelector(state => state.auth)
  const { appErr } = useSelector(state => state.app)
  const dispatch = useDispatch()
  const history = useHistory()
  const query = useQuery()
  const fallBack = query.get('fallBack')

  useEffect(() => {
    if (isLoggedIn && !appErr.length) {
      const url = fallBack || '/'
      history.push(url)
    }
  }, [isLoggedIn, appErr, fallBack, history])

  useEffect(() => {
    appErr.forEach(({ name, isError }) => {
      if (isError && (name === ERR_LOGIN || name === ERR_NETWORK)) {
        dispatch(setIsLogedIn(false))
        dispatch(setIsLoggingIn(false))
      }
    })
  }, [appErr, dispatch])

  return (
    <div className="registration-form">
      <div className="login-box">
        <div className="form-icon">
          <img src="/assets/img/GMTS_horizontal_logo.png" alt="" />
        </div>
        <Formik
          initialValues={{ password: '', userName: '' } as TAuthAPI.Body.Login}
          validate={values => {
            const errors: { [x in keyof TAuthAPI.Body.Login]?: string } = {}
            if (!values.password) {
              errors.password = 'Required'
            }
            if (!values.userName) {
              errors.userName = 'Required'
            }
            return errors
          }}
          onSubmit={values => {
            dispatch(loginAction(values))
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-user" /></span>
                  </div>
                  <input
                    value={values.userName}
                    onChange={handleChange}
                    name="userName"
                    className="form-control"
                    placeholder="ユーザー名"
                    type="text"
                  />
                </div>
                {errors.userName && touched.userName && errors.userName}
              </div>
              <div className="mb-2">
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><i className="fas fa-lock" /></span>
                  </div>
                  <input
                    value={values.password}
                    onChange={handleChange}
                    name="password"
                    className="form-control"
                    placeholder="パスワード"
                    type="password"
                  />
                </div>
                {errors.password && touched.password && errors.password}
              </div>
              <div className="form-group text-remember custom-control custom-checkbox">
                <input id="rememberMe" type="checkbox" className="custom-control-input" name="rememberMe" />
                <label htmlFor="rememberMe" className="custom-control-label custom-checkbox-login">次回ログイン省略</label>
              </div>
              <div className="form-group text-center">
                <button disabled={isLoggingIn} type="submit" className="btn btn-block create-account">
                  {isLoggingIn ? 'ログインしている' : 'ログイン'}
                </button>
              </div>
            </form>
          )}
        </Formik>
        <div className="d-flex justify-content-center link"><Link to="/forgot-password">パスワードを忘れた場合はこちら</Link></div>
      </div>
    </div>
  )
}

export default withPreventFromUser(Login)
